module.exports = __webpack_public_path__ + "static/setup_suzie-313c77630001546f50572b238696f0a1.jpg";